import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProvider } from "@/redux/baseQuery";
import { createSearchParams } from "react-router-dom";
import { GetMonthlyInvoiceParams, GetMonthlyInvoiceResponse, RawMonthlyInvoice } from "./types";
import { transformMonthlyInvoice } from "./helpers";

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: baseQueryWithProvider("payment"),
  endpoints: (builder) => ({
    getMonthlyInvoice: builder.query<GetMonthlyInvoiceResponse, GetMonthlyInvoiceParams>({
      query: (params) => `/monthly-invoice?${createSearchParams(params).toString()}`,
      transformResponse: transformMonthlyInvoice,
    }),
    getMonthlyInvoiceItem: builder.query<RawMonthlyInvoice, string>({
      query: (id) => `/monthly-invoice/${id}`,
    }),
  }),
});

export const { useGetMonthlyInvoiceQuery, useLazyGetMonthlyInvoiceItemQuery } = paymentApi;